import { TagSizing } from './types'

export const TAG_DEFAULT_SIZING: TagSizing = 'medium' as const
